import { Component, OnInit } from '@angular/core';
import { ItemsList } from '@ng-select/ng-select/lib/items-list';
import { CookieService } from 'ngx-cookie-service';
import { SpraValidationAfterSalesAdmin } from 'src/app/Models/master';
import { SpraApprovalRemarksParams } from 'src/app/Models/ops';
import { NotificationService } from 'src/app/Services/notification.service';
import { Utility } from 'src/app/Utilities/utility';
import { ActivatedRoute, Router } from '@angular/router';
@Component({
  selector: 'app-spra-approval-remarks',
  templateUrl: './spra-approval-remarks.component.html',
  styleUrls: ['./spra-approval-remarks.component.css']
})
export class SpraApprovalRemarksComponent implements OnInit {
  // public SpraApprovalRemarksParams: SpraApprovalRemarksParams;
   SpraApprovalRemarksParams: Array<SpraApprovalRemarksParams>;
   ValidationLevel: Array<SpraValidationAfterSalesAdmin>;
   ValidationLevelCheck: Array<SpraValidationAfterSalesAdmin>;
   private utility: Utility;
   public Level:any;
   public IsSalesAdmin:boolean = false;
   public ShowReviewButton:boolean = false;
   public IsFromApprovedlist:boolean = false;
   public ParentSpraDetails:any ={};

   

  constructor( private cookieService: CookieService,
    private _NotificationService: NotificationService
    ,private router: Router
    ) { 
    this.SpraApprovalRemarksParams = new Array<SpraApprovalRemarksParams>();
    this.utility = new Utility(this.cookieService);
    this.ValidationLevel = new Array<SpraValidationAfterSalesAdmin>();
    this.ValidationLevelCheck = new Array<SpraValidationAfterSalesAdmin>();
    
    //this.SpraApprovalRemarksParams[0].AppStatus = "A";
    //  this.Level= this.SpraApprovalRemarksParams.AppLevel;
    // this.SPRAApprovalRemarksArray = new Array<SpraApprovalRemarksParams>();
    // this.SPRAApprovalRemarksArray.push(new SpraApprovalRemarksParams());
  }

  ngOnInit(): void {
    // this.SpraApprovalRemarksParams.filter((fsa)=> {return fsa.Tag==0}).forEach((sv)=>{ 
    //   sv.AppStatus="A";
    // });
    //this.SpraApprovalRemarksParams[0].AppStatus = "A";
    // let  spraApp :SpraApprovalRemarksParams;
    // spraApp=this.SpraApprovalRemarksParams.filter((item)=>{
    //   return item.Tag==0}               
    //   )[0];
    //   spraApp.AppStatus="A";
     
     
  }

  // checkStatus(rdApprove:any,rdReject:any){
  //   let  spraApp :SpraApprovalRemarksParams;
  //   spraApp=this.SpraApprovalRemarksParams.filter((item)=>{
  //     return item.Tag==0}               
  //     )[0];

  //     if (rdApprove.checked == true)
  //     {
  //       spraApp.AppStatus="A";
  //     }
  //     else{
  //       spraApp.AppStatus="R";

  //     }
     
  //    return false;
  // }

  
  Validation():boolean{   
    
    //Added by rahul yadav to mandtory atleast three empoyee selection 
    this.ValidationLevelCheck = this.ValidationLevel.filter((empid)=> empid.EmployeeId) 
    let IsSrno:boolean = true;
    let count:number = 1;
    //Added by rahul yadav to to check srno 
    this.ValidationLevelCheck.forEach((sno)=>{ 
      if(sno.SrNo != count){
        IsSrno = false;
      }
      count++;
    });
   let IsValidation:boolean = true;
    this.SpraApprovalRemarksParams.filter((fsa)=> {return fsa.Tag==0}).forEach((sv)=>{ 
      // debugger
      if(this.IsFromApprovedlist){
         sv.AppStatus = "A";
      }
      if(!this.utility.CheckStringRequired(sv.Remarks)){
        this._NotificationService.showError("Please enter validation remarks.", "Validation");
        IsValidation = false;
      }else if(!this.utility.CheckStringRequired(sv.AppStatus)){
        this._NotificationService.showError("Please select valdation status (Approved/Reject).", "Validation Stauts");
        IsValidation = false;
      }else if(this.IsSalesAdmin && this.ValidationLevelCheck.length<2 && sv.AppStatus?.toString() == "A" ){
        this._NotificationService.showError("At least two Employee required for further validation.", "Validation Required");
        IsValidation = false;
      }
      else if(this.IsSalesAdmin && !IsSrno){
        this._NotificationService.showError("Please select employee in order", "Validation Required");
        IsValidation = false;
      }

    });
    return IsValidation;
  }

  ValidationHierarchyChange(_SpraValidationAfterSalesAdmin:Array<SpraValidationAfterSalesAdmin>){
    
    this.ValidationLevel = _SpraValidationAfterSalesAdmin;
    
  }

  onRequestClick(){
    let data =  {IsForPriceRef:false,SPRAId: this.ParentSpraDetails[0].Id,RefId:this.ParentSpraDetails[0].RefId,salecode:this.ParentSpraDetails[0].SaleCode,officeId:this.ParentSpraDetails[0].OfficeID,CompanyID:this.ParentSpraDetails[0].CompanyId,ProfitTag:true };
   // this.router.navigateByUrl("spra-view-ops",{ state:{data:data}});
    this.router.navigate([], {
      state: data
    }).then(result => {  
      window.open("spra-view-ops/"+btoa(JSON.stringify(data)) +"", '');     
    });
   }
}
